import { render, staticRenderFns } from "./TokenRefresh.vue?vue&type=template&id=4061d85e&"
import script from "./TokenRefresh.vue?vue&type=script&lang=js&"
export * from "./TokenRefresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports